/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Télécharger sur l'App Store",
      "Rencontre les groupes à proximité en vrai",
      "Discute avec tes nouveaux amis dans les Hives.",
      "Trouve ta tribu",
      "Quelle que soit ta passion, il y a une Hive pour toi !",
      "Un lieu sûr où tu peux être toi-même",
      "Choisis entre des Hives cachées ou visibles.",
      "Commencer",
      "Quelle que soit ta passion, il y a une Hive pour toi",
      "Fais la connaissance d'un nouveau groupe de gens dans les Hives sur Bumble BFF",
      "Tu as reçu une invitation à rejoindre une Hive",
      "Rencontre de nouveaux groupes de personnes locales dans les Hives, la nouvelle fonctionnalité de Bumble BFF. Crée ton profil BFF sur l'appli Bumble dès aujourd'hui.",
      "Télécharger sur Google Play",
      "Gérer les cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
